import { CrossIcon } from '@datacamp/waffles-icons';
import tokens from '@datacamp/waffles-tokens';
import { css } from '@emotion/react';
import { jsx as ___EmotionJSX } from "@emotion/react";

var CloseButton = function CloseButton(_ref) {
  var className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onClick = _ref.onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size;
  return ___EmotionJSX("button", {
    "aria-label": "Close",
    className: className,
    css: /*#__PURE__*/css({
      ':active': {
        color: tokens.colors.green
      },
      ':disabled': {
        color: tokens.colors.greyMedium
      },
      ':disabled:hover, :disabled:focus': {
        backgroundColor: 'transparent'
      },
      ':focus': {
        backgroundColor: tokens.colors.greyLight
      },
      ':hover': {
        backgroundColor: tokens.colors.greyLight
      },
      alignItems: 'center',
      backgroundColor: 'white',
      border: 'none',
      borderRadius: 2,
      color: tokens.colors.navy,
      cursor: disabled ? 'not-allowed' : 'pointer',
      display: 'flex',
      flexDirection: 'column',
      height: size === 'large' ? 32 : 20,
      justifyContent: 'center',
      outline: 'none',
      padding: 0,
      width: size === 'large' ? 32 : 20,
      zIndex: tokens.zIndex.default
    }, process.env.NODE_ENV === "production" ? "" : ";label:CloseButton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    disabled: disabled,
    onClick: onClick,
    type: "button"
  }, ___EmotionJSX(CrossIcon, {
    "aria-hidden": true,
    size: size === 'large' ? 'medium' : 'small',
    title: ""
  }));
};

export default CloseButton;